<mat-tab-group matDialogTitle
               dynamicHeight="true"
               class="tab-header">
    <mat-tab #descriptionTab
             [label]="'robot_modal_tabs_Description' | translate ">
    </mat-tab>
    <mat-tab #settingsTab
             [label]="'robot_modal_tabs_Runtime' | translate">
    </mat-tab>
</mat-tab-group>

<form [formGroup]="robotForm"
      (submit)="onSubmit()"
      uiPreventAutofill>
    <mat-dialog-content class="mat-typography">
        <div [hidden]="!descriptionTab.isActive">
            <ng-container *uiContentLoading="loadingData$ | async">
                <div *ngIf="context.isNewEntry"
                     class="robot-type-title">
                    <h2>{{ formTitle }}</h2>
                    <p>{{ formDescription }}</p>
                </div>

                <mat-form-field *ngLet="robotForm.get(RobotFormControl.machine) as machineField">
                    <ui-suggest [clearable]="false"
                                [customValueLabelTranslator]="translateMachineLabel"
                                [defaultValue]="(
                                (isMachinesCreateGranted$ | async) ?
                                    'robot_modal_form_machine_empty' :
                                    'robot_modal_form_machine_empty_only_select'
                                ) | translate"
                                [displayCount]="5"
                                [disabled]="!(isMachinesViewGranted$ | async)  ||
                                         (isRobotBusy$ | async)"
                                [enableCustomValue]="isMachinesCreateGranted$ | async"
                                [formControlName]="RobotFormControl.machine"
                                [placeholder]="'robot_modal_form_machine' | translate"
                                [readonly]="!context.isNewEntry"
                                [required]="true"
                                [searchable]="true"
                                [searchSourceFactory]="machineSearchFactory"
                                [uiAutofocus]="!context.isDuplicate"
                                customValueTranslationKey="robot_modal_form_machine_custom_value"
                                direction="down"
                                data-cy="robot-machine">
                    </ui-suggest>
                    <mat-error *ngIf="machineField.hasError('text.maxlength')"
                               [translateParams]="{
                                  max: machineField.getError('text.maxlength').requiredLength
                            }"
                               translate>
                        robot_modal_form_machine_max_warning
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngLet="robotForm.get(RobotFormControl.name) as nameField">
                    <input [formControlName]="RobotFormControl.name"
                           [placeholder]="'robot_modal_form_name' | translate"
                           [uiAutofocus]="!context.isNewEntry ||
                                           context.isDuplicate ||
                                           createAnother"
                           [refocus]="refocusField$ | async"
                           matInput
                           required
                           data-cy="robot-name" />
                    <mat-error *ngIf="nameField.hasError('maxlength')"
                               [translateParams]="{
                                    max: nameField.getError('maxlength').requiredLength
                               }"
                               translate>
                        robot_modal_form_name_max_warning
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <ui-suggest [clearable]="false"
                                [disabled]="isRobotBusy$ | async"
                                [displayCount]="5"
                                [formControlName]="RobotFormControl.type"
                                [items]="robotTypeDropdownEntries"
                                [placeholder]="'robot_modal_form_type' | translate"
                                [required]="true"
                                direction="up"
                                data-cy="robot-type">
                    </ui-suggest>
                </mat-form-field>

                <ng-container *ngIf="selectedRobotType !== RobotType.Attended"
                              [formGroup]="robotCredentialsForm">
                    <mat-form-field>
                        <ui-suggest [clearable]="false"
                                    [formControlName]="RobotCredentialsControl.credentialStore"
                                    [disabled]="selectedCredentialStore && credentialStoreDropdownEntries.length === 1"
                                    [displayCount]="5"
                                    [items]="credentialStoreDropdownEntries"
                                    [placeholder]="'robot_modal_form_credential_store' | translate"
                                    [required]="true"
                                    direction="up"
                                    data-cy="robot-credential-store">
                        </ui-suggest>
                    </mat-form-field>
                </ng-container>

                <mat-form-field *ngLet="robotForm.get(RobotFormControl.username) as usernameField">
                    <input [formControlName]="RobotFormControl.username"
                           [placeholder]="'robot_modal_form_username' | translate"
                           [readonly]="isRobotBusy$ | async"
                           (keyup)="resetPassword()"
                           matInput
                           required
                           uiPreventAutofill
                           data-cy="robot-username" />
                    <mat-error *ngIf="usernameField.hasError('maxlength')"
                               [translateParams]="{
                                    max: usernameField.getError('maxlength').requiredLength
                               }"
                               translate>
                        robot_modal_form_username_max_warning
                    </mat-error>
                </mat-form-field>

                <ng-container *ngIf="credentialStoreConfigForm &&
                                     selectedRobotType !== RobotType.Attended"
                              [formGroup]="credentialStoreConfigForm">
                    <ng-container *ngIf="!selectedCredentialStore.details.isReadOnly">
                        <mat-form-field
                                        *ngLet="credentialStoreConfigForm.get(CredentialStoreConfigControl.password) as passwordField">
                            <input #passwordInput
                                   [formControlName]="CredentialStoreConfigControl.password"
                                   [placeholder]="'robot_modal_form_password' | translate"
                                   autocomplete="off"
                                   type="password"
                                   matInput
                                   uiPreventAutofill
                                   data-cy="robot-password" />
                            <span matSuffix>
                                <ui-password-toggle [element]="passwordInput"
                                                    [tooltipShow]="'password_toggle_show' | translate"
                                                    [tooltipHide]="'password_toggle_hide' | translate">
                                </ui-password-toggle>
                            </span>
                            <mat-error *ngIf="passwordField.hasError('maxlength')"
                                       [translateParams]="{
                                            max: passwordField.getError('maxlength').requiredLength
                                       }"
                                       translate>
                                robot_modal_form_password_max_warning
                            </mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                                  *ngIf="selectedCredentialStore.type.genericType === CredentialStoreGenericType.SecureStore">
                        <mat-form-field>
                            <input [formControlName]="CredentialStoreConfigControl.externalName"
                                   [placeholder]="'robot_modal_form_external_name' | translate"
                                   matInput
                                   data-cy="robot-external-name" />
                        </mat-form-field>
                    </ng-container>
                </ng-container>

                <mat-form-field *ngLet="robotForm.get(RobotFormControl.description) as descriptionField">
                    <input [formControlName]="RobotFormControl.description"
                           [placeholder]="'robot_modal_form_description' | translate"
                           matInput
                           data-cy="robot-description" />
                    <mat-error *ngIf="descriptionField.hasError('maxlength')"
                               [translateParams]="{
                                    max: descriptionField.getError('maxlength').requiredLength
                               }"
                               translate>
                        robot_modal_form_description_max_warning
                    </mat-error>
                </mat-form-field>

                <div class="checkbox-container">
                    <ng-container *ngIf="selectedRobotType !== RobotType.Attended"
                                  [formGroup]="robotCredentialsForm">
                        <div *ngIf="isSmartCardAuthFeatureEnabled">
                            <mat-checkbox (change)="onCredentialSmartCardChange()"
                                          [formControlName]="RobotCredentialsControl.isCredentialSmartCard"
                                          matInput>
                                {{ 'robot_modal_form_smartcard_password' | translate }}
                            </mat-checkbox>
                        </div>
                    </ng-container>
                </div>

                <div class="checkbox-container">
                    <ng-container *ngIf="[RobotType.Development, RobotType.StudioX].includes(selectedRobotType)">
                        <mat-checkbox [formControlName]="RobotFormControl.isExternalLicense">
                            {{ 'robot_modal_form_isExternalLicense' | translate}}
                        </mat-checkbox>
                    </ng-container>
                </div>

            </ng-container>
        </div>

        <div [hidden]="!settingsTab.isActive"
             class="settings-tab">
            <ui-execution-settings *uiContentLoading="loadingData$ | async"
                                   [settingsConfig]="executionSettingsConfig$ | async"
                                   [settingsValues]="executionSettingsValues">
            </ui-execution-settings>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <mat-checkbox *ngIf="context.isNewEntry"
                      [(ngModel)]=" createAnother"
                      [ngModelOptions]="{ standalone: true }"
                      class="create-another"
                      data-cy="robot-create-another">
            {{ 'robot_modal_form_createAnother' | translate }}
        </mat-checkbox>

        <button mat-button
                mat-dialog-close
                data-cy="robot-cancel"
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>

        <button [spinnerButtonLoading]="submitting$ | async"
                [disabled]="isSubmitDisabled"
                mat-flat-button
                ui-spinner-button
                color="primary"
                type="submit"
                data-cy="robot-submit">
            {{ (context.isNewEntry ? 'modal_action_create' : 'modal_action_update') | translate }}
        </button>
    </mat-dialog-actions>
</form>
